module.exports = __webpack_public_path__ + "static/media/challenge.d99355dd.jpg";